// extracted by mini-css-extract-plugin
module.exports = {"auth-page":"Reset_auth-page__2fCXB","auth-footer":"Reset_auth-footer__2KkWZ","btn-container":"Reset_btn-container__6RSF_"};